import { getUserConfiguration } from "./ConfigurationService";
import { setPandoraMode } from "./LightMode";

export async function appInitializer(): Promise<void> {
  const envMode = process.env.REACT_APP_PANDORA_MODE;

  if (envMode === "light" || envMode === "full") {
    console.log("Mode from env:", envMode);
    setPandoraMode(envMode);
    return;
  }

  try {
    const { config } = await getUserConfiguration();
    console.log("Mode from user config:", config.pandoraMode);
    setPandoraMode(config.pandoraMode ?? "full");
  } catch (error) {
    console.error("App initialization failed", error);
    setPandoraMode("full");
  }
}